import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';
import {t} from '@/i18n'
export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_calendar_events.breadcrumb.application_calendar_events_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_calendar_events.breadcrumb.application_calendar_events_label2'),
    link: '/application/calendar',
  },
  {
    label: t('pages.application_calendar_events.breadcrumb.application_calendar_events_label3'),
  },
];
